<template>
  <div class="bow-form-wrapper">
    <PageMainTitle>
      <slot name="Title"></slot>
    </PageMainTitle>

    <form
      v-if="hasFormContent"
      class="bow-form"
      onsubmit.prevent="save"
    >
      <slot name="FormContent"></slot>
    </form>

    <slot name="Content"></slot>

    <div v-if="errorMsg">
      {{errorMsg}}
    </div>
  </div>
</template>

<script>
  import { Component, Prop, Vue } from 'vue-property-decorator'
  import PageMainTitle from '@/components/common/PageMainTitle'

  @Component({
    name: 'Form',
    props: ['errorMsg'],
    components: {
      PageMainTitle
    }
  })
  class Form extends Vue {
    @Prop errorMsg

    get hasFormContent() {
      return this.$slots.FormContent && this.$slots.FormContent.length;
    }
  }

  export default Form
</script>

<style scoped lang="less">
.bow-form {
  display: flex;
  flex-direction: column;
  width: min-content;
  margin: var(--margin--small) auto;
}

.bow-form-wrapper {
  background-color: white;
}
</style>
